import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";

const moduleArea = {
  namespaced: true,

  state: {
    name: 'area',
    nextSeqCode: null,
    busSeqCode: null,
    fromKP: null,

    areas: []
  },

  mutations,
  getters,
  actions
}

export default moduleArea;